<template>
    <v-dialog :value="true" :persistent="true" :width="500">
        <v-card class="grey lighten-4">

            <div class="centered-row primary white--text px-2 py-1">
                <v-icon color="white">verified_user</v-icon>
                <div style="width: 100%" class="pl-2">
                    Two Factor Verification
                </div>


            </div>


            <div class="px-2 pt-2 centered-row">
                <div style="width: 50%">An OTP has been sent to:</div>
                <div style="width: 50%"><strong>{{config.sentTo}}</strong></div>
            </div>

            <div class="px-2 pt-2">
                <v-text-field
                        class="pa-0 ma-0"
                        hide-details
                        prepend-inner-icon="vpn_key"
                        light
                        solo
                        label="Please confirm the code below"
                        placeholder="OTP Code"
                        :height="30"
                        mask="###-###"
                        v-model="otp"
                        :disabled="confirming"
                        ref="otpEdit"
                        @keydown.enter="!!otp && otp.length === 6 ? confirmOTP() : null"
                >

                </v-text-field>
            </div>

            <div v-if="otpError" class="pt-2 text-xs-center error--text caption">
                <strong>{{otpError}}</strong>
            </div>

            <div class="pt-2 px-2 pb-2">
                <v-layout row justify-space-between>
                    <v-flex shrink>
                        <v-btn
                                class="px-2 ma-0"
                                color="primary"
                                flat
                                @click="sendAlt"
                                :loading="sendingAlt"
                                :disabled="sendingAlt"
                                v-if="!altSent"
                        >
                            Send Via {{config.alt.type}}
                        </v-btn>
                    </v-flex>
                    <v-flex shrink>
                        <v-btn
                                v-if="!!doubleCheck"
                                class="pa-0 ma-0 mr-2"
                                color="secondary"
                                outline
                                @click="cancelConfirm()"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                class="pa-0 ma-0"
                                color="secondary"
                                :disabled="(!!otp ? otp.length < 6 : true) || confirming"
                                :loading="confirming"
                                @click="!doubleCheck ? confirmOTP() : confirmDoubleCheck()"
                        >
                            Next
                        </v-btn>
                    </v-flex>

                </v-layout>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

const EventEmitter      = require('events');
const emitter           = new EventEmitter();

export default {
    props: {
        config: Object,
        getOS: Function,
        setCookie: Function,
        doubleCheck: {
            default: false,
            type: [Object, Boolean]
        }
    },
    data() {
        return {
            otp: null,
            altSent: false,
            sendingAlt: false,
            confirm: false,
            confirming: false,
            otpError: null,
            emitter: emitter
        }
    },
    watch: {
        otp() {
            this.otpError = null
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs.otpEdit.focus()
        }, 500)
    },
    methods: {
        sendAlt() {
            this.sendingAlt = true;
            this.$newReq('GET', `login/twoFactor/SendAlt/${this.config.entityID}/${this.config.userID}`, null, false)
                .then(({sentTo}) => {
                    this.config.sentTo = sentTo
                    this.altSent = true;
                    this.$snack.info('Two Factor OTP Sent')
                })
            .catch(e => {
                console.log(e)
                this.$snack.networkError()
            })
            .finally(() => {
                this.sendingAlt = false
            })
        },

        confirmDoubleCheck() {
            this.otpError = null
            this.confirming = true;
            this.$newReq('GET', `users/twoFactor/check/${this.config.entityID}/${this.config.userID}/${this.otp}`)
                    .then(() => {
                        emitter.emit('result', {status: true})
                    })
                    .catch(() => {
                        this.otpError = 'Invalid OTP'
                    })
                    .finally(() => {
                        this.confirming = false
                    })
        },

        cancelConfirm() {
            emitter.emit('result', {status: false})
        },

        confirmOTP() {
            this.otpError = null
            this.confirming = true;
            this.$newReq('GET', `login/twoFactor/confirm/${this.config.entityID}/${this.config.userID}/${this.getOS()}/${this.otp}`, null, false)
                    .then((data) => {
                        let username = data.token.userKey.substr(data.token.userKey.indexOf('-') + 1).toLowerCase()
                        this.setCookie(username, data.deviceID, 120)
                        this.$emit('OTPSuccess', data.token)
                    })
                    .catch(() => {
                        this.otpError = 'Invalid OTP'
                    })
                    .finally(() => {
                        this.confirming = false
                    })
        }
    },
    computed: {

    },
}
</script>

<style scoped>

</style>